export default __webpack_public_path__ + "static/1-2612ca646f2d30d1f33ea31c3453fc58.png";